
import { setTieuChuanSanPhamApi } from '../../../api/set-tieu-chuan/setTieuChuanSanPhamApi';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { ISetTieuChuanSanPham } from '../../../model/respone/set-tieu-chuan/ISetTieuChuanSanPham';
import { eSetTieuChuanSanPhamActionTypeIds, ISetTieuChuanSanPhamActions } from '../../action-types/set-tieu-chuan/ISetTieuChuanSanPhamActions';
import { rootActions } from '../../actions/rootActions';

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
const mainAction = rootActions.setTieuChuan.sanPham;
export function* setTieuChuanSanPhamSaga(): any {
    yield takeLatest(eSetTieuChuanSanPhamActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eSetTieuChuanSanPhamActionTypeIds.LOAD_DETAIL_START, loadDetailBySetTieuChuanWorker)
    yield takeEvery(eSetTieuChuanSanPhamActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eSetTieuChuanSanPhamActionTypeIds.DELETE_START, deleteWorker)
}

function* loadDetailBySetTieuChuanWorker(action: ISetTieuChuanSanPhamActions): any {
    const payload = action.payload as number
    const res: IBaseRespone = yield call(setTieuChuanSanPhamApi.SelectDetailByStc, payload)
    if (res.is_success) {
        yield put(mainAction.LOAD_DETAIL_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_DETAIL_ERROR(res.message ?? "Có lỗi"))
    }
}
function* loadWorker(action: ISetTieuChuanSanPhamActions): any {
    const res: IBaseRespone = yield call(setTieuChuanSanPhamApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ISetTieuChuanSanPhamActions): any {
    let res: IBaseRespone;
    const SetTieuChuanSanPham = action.payload as ISetTieuChuanSanPham;
    if (SetTieuChuanSanPham.id > 0) {
        res = yield call(setTieuChuanSanPhamApi.Update, SetTieuChuanSanPham)
    } else {
        res = yield call(setTieuChuanSanPhamApi.Insert, SetTieuChuanSanPham)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ISetTieuChuanSanPhamActions): any {
    const res: IBaseRespone = yield call(setTieuChuanSanPhamApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}